/**
 * Admin "member view": an admin browsing the site as an ordinary member sees.
 *
 * The server does the real work — every request carries `x-gwc-view-mode`, and
 * an admin's roles are downgraded to `user` for that request. This module only
 * remembers which mode the browser is in.
 *
 * Persisted so a reload keeps the mode rather than silently dropping back to the
 * admin view. Read at module load, before the first request goes out, so the
 * session restore and every query after it already carry the right header.
 * Storage can throw (private windows, blocked site data) — then the mode simply
 * lasts until the tab closes.
 */
const STORAGE_KEY = 'gwc.viewMode';

function readStored(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'member';
  } catch {
    return false;
  }
}

let memberMode = readStored();
export const isMemberMode = () => memberMode;
export const setMemberMode = (value: boolean) => {
  memberMode = value;
  try {
    if (value) window.localStorage.setItem(STORAGE_KEY, 'member');
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* storage unavailable — the in-memory mode still applies */
  }
};
